import AuditCreativeCard from "components/audit/audit_creative_card"
import CustomFiltersFormContainer from "components/settings/custom_filters_form_container"
import FormContainer from "components/higher_order_components/form_container"
import InfiniteScrollContainer from "components/higher_order_components/infinite_scroll_container"
import ModalContainer from "components/higher_order_components/modal_container"
import SnapchatAdAccountSelect from "components/account_setup/snapchat_ads/SnapchatAdAccountSelect"

# NB: This file is to place random containers so we don't keep generating tons of files with one line

# Modal Launch Button
import { Button } from  "@duik/it"
export ModalLaunchButton = ModalContainer(Button)

export AuditCreativeCards = InfiniteScrollContainer(AuditCreativeCard)

# Snapchat Ad Account Selection
export SnapchatAdAccountSelectForm = FormContainer(SnapchatAdAccountSelect)

# Custom Filters Creation Form
export CustomFiltersForm = FormContainer(CustomFiltersFormContainer)
